import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Torah = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32v448c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128v448h384V32zm80-32c-26.5 0-48 14.3-48 32v448c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2.9-6.4 2.5-9.2l28.2-48.5-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2 0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3 0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2 0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9C334 392.2 327.3 396 320 396s-13.9-3.8-17.6-10.1L271 332h-56.7c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7 21.2-36.4h-42.4l21.2 36.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52h-70.4l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zm16.4-75.8H383l16.4 28.2 16.4-28.2zM320 143.6 298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204h-32.8zM257 308l-16.4-28.2-16.4 28.2H257z"
  }));
});
Torah.displayName = 'Torah';
export var TorahDimensions = {
  height: 512,
  width: 640
};